import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { filterUserAndSharedProfiles, toProfilesResponse } from "../helpers/accessLevelFilters";
import type { ProfilesResponseDto } from "../types/dto";

import { contactsSearchProfilesQueryKeys } from "./queryKeyFactory";

export const useGetAllContactProfilesQuery = () => {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: contactsSearchProfilesQueryKeys.allProfiles(),
        placeholderData: keepPreviousData,
        queryFn: () => salesApiService.contactsSearchProfiles.fetchAllProfiles(),
        select: (data: ProfilesResponseDto): ProfilesResponseDto => {
            const profiles = filterUserAndSharedProfiles(data.profiles);
            return toProfilesResponse(profiles);
        },
    });
};
